<template>
  <div class="form-overview">
    <ul class="form-overview-list">
      <li
        v-for="(category, categoryKey) in i18n.form.labels.wizardOverview.categories"
        :key="categoryKey"
        class="form-overview-list-item"
      >
        <h2>{{ category.title }}</h2>
        <div class="form-overview-item">
          <div
            v-if="category.imageUrl"
            class="form-overview-item-top"
          >
            <img
              class="form-overview-item-img"
              :src="category.imageUrl"
              alt=""
            >
          </div>
          <div class="form-overview-item-bottom">
            <a
              v-for="(link, index) of category.links"
              :key="index"
              :href="link.href"
              :target="link.target"
              :title="link.label"
              class="form-overview-link"
            >{{ link.label }}</a>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'WizardOverview',
  props: {
    i18n: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="postcss">
.form-overview {
  @apply mb-5;

  &-list {
    @apply grid grid-cols-12 list-none;

    @screen md {
      @apply gap-16;
    }

    &-item {
      @apply flex flex-col h-full relative col-span-12;

      @screen lg {
        @apply col-span-4 mb-0;
      }
    }
  }

  &-item {
    @apply flex flex-col h-full relative rounded mb-8;
    box-shadow: 0px 4px 20px rgb(54, 25, 5, 0.12);

    &-top {
      @apply flex flex-col relative rounded-t overflow-hidden;

      > img {
        height: 300px;
        object-fit: cover;
        object-position: center;
      }

      &::before {
        @apply block;
        content: '';
        background-position: center bottom;
        background-repeat: no-repeat;
        padding-bottom: 9.7222222222vw;
        background-size: 100%;
        position: absolute;
        bottom: -1px;
        left: -1px;
        background-image: url('~@/assets/images/curve-news-white.svg?inline');
        width: calc(100% + 2px);
      }
    }

    &-bottom {
      @apply flex flex-col px-7 py-10 rounded-b overflow-hidden flex-auto justify-start bg-white;

      .form-overview-link {
        @apply w-full text-black text-lg font-medium justify-start text-left p-0 mb-0;
        background-image: none;
        background-image: url('~@/assets/svg/chevron-right-secondary.svg?inline');
        background-repeat: no-repeat;
        background-position: right 4px center;
        background-size: auto;
        margin-top: 12px;
        margin-bottom: 12px;
        transition: background-position 250ms ease;
        padding-right: 2rem;
        text-decoration: none;

        .theme-secondary & {
          background-image: url('~@/assets/svg/theme-secondary/ts-chevron-right-secondary.svg?inline');
        }

        &:hover {
          text-decoration: underline;
          background-position: right 0px center;
        }
      }
    }
  }
}
</style>
